import React from 'react'
import styled from 'styled-components'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { featured_services } from '../utils/constants'



const Featured = () => {
  return (
    <Wrapper>
      <MDBContainer fluid>
          {/* ********************* MAIN TEXTS ***************/}
          <MDBRow className="mb-5 w-100">
              <MDBCol sm="12">
                  <h1 className="font-weight-bold text-center mb-4 display-3">Psicoterapia</h1>
              </MDBCol>
          </MDBRow>
          {/* ********************* ICONS AND IMAGES >> ver constants > feature_services ***************/}
          <MDBRow className="featured-item__main-container flex-nowrap mb-4">
              {
                featured_services.map((service) => {
                  const {id, icon, title, bgColor} = service;
                  return (
                      <MDBCol key={id} md="12" lg="3" className="d-flex align-items-center flex-column py-3 featured-item__container mx-sm-0" style={{backgroundColor: bgColor}}>
                          <div className="featured-icon__container d-flex justify-content-center flex-column align-items-center border border-3 mt-3">
                                {icon}
                          </div>
                          <h4 className="text-center my-md-4">{title}</h4>
                      </MDBCol>
                  )
                })
              }  
          </MDBRow>

      
      </MDBContainer>
    </Wrapper>
  )
}
const Wrapper = styled.section`
  background: var(--website-featured-bg-color);
  padding: 5rem;
  
  .featured-item__container {
    border-radius: 15px;
    border: 5px solid var(--website-featured-bg-color)
    
  }
  .featured-icon__container {
    width: 100px;
    height: 100px;
    background-color: var(--website-main-color);
    border-radius: 50%
  }
  .featured-icon{
    font-size: 2.9rem;
    color: var(--clr-white);
  }

  @media (max-width: 992px) {
    .featured-item__main-container {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    padding: 1rem;
    margin-bottom: 5rem;
  }

`
export default Featured
